import {
  RESET_REPORT_STATE,
  LIST_REPORTS_SUCCESS,
  LIST_REPORTS_FAILURE,
  REPORT_DETAIL_SUCCESS,
  REPORT_FILTERS_SUCCESS,
  CREATE_REPORT_SUCCESS,
  CREATE_REPORT_FAILURE,
  LIST_ATTRIBUTES_SUCCESS,
  LIST_ATTRIBUTES_FAILURE,
  EDIT_REPORT_SUCCESS,
  EDIT_REPORT_FAILURE,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_FAILURE,
  SHOW_SOLD_REPORT_DEALS_SUCCESS,
  SHOW_SOLD_REPORT_DEALS_FAILURE,
  SHOW_BOUGHT_REPORT_DEALS_SUCCESS,
  SHOW_BOUGHT_REPORT_DEALS_FAILURE
} from '../actions/report.actions';
import {
  API_REQUEST
} from '../actions/helper.actions';

const initialState = {
  pending: false,
  reports: [],
  error: '',
  name: '',
  description: '',
  selectedAttributesList: [],
  attributesList: [],
  checkSelectAllAttributes: false,
}

const updateAttribute = (attributeWithFilters, attribute) => {
  if (attributeWithFilters.attribute_name === attribute.attribute_name) {
    attribute['checked'] = attributeWithFilters.checked
    attribute['condition'] = attributeWithFilters['condition']
    attribute['orderId'] = attributeWithFilters['orderId']
    if (attributeWithFilters['attribute_type'] === "date") {
      attribute['fromDate'] = attributeWithFilters['fromDate'];
      attribute['toDate'] = attributeWithFilters['toDate'];
    } else {
      attribute['value'] = attributeWithFilters['value']
    }
  }
  return attribute
}

const report = (state = initialState, action) => {

  switch (action.type) {
    case RESET_REPORT_STATE:
      return {
        ...initialState,
        pending: false,
      }
    case API_REQUEST:
      return {
        ...state,
        pending: true,
      }

    case LIST_REPORTS_SUCCESS:
      return {
        ...state,
        pending: false,
        reports: action.resp.data.results
      }

    case LIST_REPORTS_FAILURE:
      return {
        ...state,
        pending: false
      }
    case REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        name: action.resp.name,
        description: action.resp.description,
        selectedAttributesList: action.resp.selectedAttributes,
        checkSelectAllAttributes: action.resp.checkSelectAllAttributes
      }
    case REPORT_FILTERS_SUCCESS:
      action.resp.selectedAttributes.map((attributeWithOrder) => {
        state.attributesList.map((attribute) => {
          attribute = updateAttribute(attributeWithOrder, attribute)
        })
      })
      return {
        ...state,
        name: action.resp.name,
        description: action.resp.description,
        selectedAttributesList: action.resp.selectedAttributes,
        checkSelectAllAttributes: action.resp.checkSelectAllAttributes,
      }

    case CREATE_REPORT_SUCCESS:
      return {
        ...initialState,
        pending: false
      }
    case CREATE_REPORT_FAILURE:
      return {
        ...state,
        pending: false,
      }
    case LIST_ATTRIBUTES_SUCCESS:
      var initialReportId = 1;
      action.resp.data.attributes.forEach(function (item) {
        item["id"] = String(initialReportId++)
      });
      return {
        ...state,
        selectedAttributesList: [],
        checkSelectAllAttributes: false,
        attributesList: action.resp.data.attributes
      }
    case LIST_ATTRIBUTES_FAILURE:
      return {
        ...state,
        pending: false
      }
    case EDIT_REPORT_SUCCESS:
      state.attributesList.map(attribute => {
        action.resp.data.result.filters.map((responseAttribute) => {
          attribute = updateAttribute(responseAttribute, attribute)
        })
      })
      return {
        ...state,
        name: action.resp.data.result.name,
        description: action.resp.data.result.description,
        selectedAttributesList: state.attributesList,
      }
    case EDIT_REPORT_FAILURE:
      return {
        ...state,
        pending: false
      }
    case DELETE_REPORT_SUCCESS:
      return {
        ...state,
        pending: false
      }
    case DELETE_REPORT_FAILURE:
      return {
        ...state,
        pending: false
      }
    case SHOW_SOLD_REPORT_DEALS_SUCCESS:
      return {
        ...state,
        name: action.resp.data.report.name,
        description: action.resp.data.report.description,
        pending: false
      }
    case SHOW_SOLD_REPORT_DEALS_FAILURE:
      return {
        ...state,
        pending: false,
      }

    case SHOW_BOUGHT_REPORT_DEALS_SUCCESS:
      return {
        ...state,
        name: action.resp.data.report.name,
        description: action.resp.data.report.description,
        pending: false
      }
    case SHOW_BOUGHT_REPORT_DEALS_FAILURE:
      return {
        ...state,
        pending: false,
      }

    default:
      return state
  }
}

export default report